import * as Immutable from 'immutable';
import { SET_NOTIFICATION_DRAWER_OPEN_COMPLETED } from '../../actions/notificationdrawer/types';

const schema = {
  open: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION_DRAWER_OPEN_COMPLETED:
      return state.set('open', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
